import webClient from "../config/api.config";
import { NoticeType, AppNoticePayload } from "../types/appNotice.definition";

export function requestGetAppNotices(featureType?: NoticeType) {
  return webClient.request({
    method: "get",
    url: `/app-configs`,
    params: featureType ? { feature_type: featureType } : undefined,
  });
}

export function requestCreateAppNotice(data: AppNoticePayload) {
  return webClient.request({
    method: "post",
    url: `/app-configs`,
    data,
  });
}

export function requestUpdateAppNotice(id: number, data: AppNoticePayload) {
  return webClient.request({
    method: "put",
    url: `/app-configs/${id}`,
    data,
  });
}

export function requestDeleteAppNotice(id: number) {
  return webClient.request({
    method: "delete",
    url: `/app-configs/${id}`,
  });
}
